import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/userLogin/list/userLogin.list.query.gql"
import type {
  UserLoginListQuery,
  UserLoginListQueryVariables,
} from "@/v2-backoffice-client/userLogin/list/__types__/userLogin.list.query"

type Options = QueryHookOptions<UserLoginListQuery, UserLoginListQueryVariables>

export function useUserLoginListQuery(options?: Options) {
  return useQuery<UserLoginListQuery, UserLoginListQueryVariables>(
    query,
    options,
  )
}

export type UserLoginRow = NonNullable<
  UserLoginListQuery["getUserLogins"]
>["items"][number]
